import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

import Div from './Div';

/**
 * Duration for the transition
 */
const duration = 300;

/**
 * Default Style for SideDrawerContent
 */
const defaultNotifationStyle = {
  transition: `all ${duration}ms ease-in-out`,
  opacity: 0,
};

/**
 * Trasition Styles for SideDrawerContent
 */
const transitionNotifationStyles = {
  fromTopRight: {
    entering: () => ({ opacity: 0, transform: 'translateY(-100%)' }),
    entered: (opacity, backdropFilter) => ({ opacity, transform: 'translateX(0)', backdropFilter }),
    exiting: () => ({ opacity: 0, transform: 'translateX(100%)' }),
    exited: () => ({ opacity: 0, transform: 'translateY(-100%)' }),
  },
  fromBottomRight: {
    entering: () => ({ opacity: 0, transform: 'translateX(100%)' }),
    entered: (opacity, backdropFilter) => ({ opacity, transform: 'translateX(0)', backdropFilter }),
    exiting: () => ({ opacity: 0, transform: 'translateX(100%)' }),
    exited: () => ({ opacity: 0, transform: 'translateX(100%)' }),
  },
  fromBottomLeft: {
    entering: () => ({ opacity: 0, transform: 'translateX(-100%)' }),
    entered: (opacity, backdropFilter) => ({ opacity, transform: 'translateX(0)', backdropFilter }),
    exiting: () => ({ opacity: 0, transform: 'translateX(-100%)' }),
    exited: () => ({ opacity: 0, transform: 'translateY(-100%)' }),
  },
  fromTopLeft: {
    entering: () => ({ opacity: 0, transform: 'translateY(-100%)' }),
    entered: (opacity, backdropFilter) => ({ opacity, transform: 'translateX(0)', backdropFilter }),
    exiting: () => ({ opacity: 0, transform: 'translateX(-100%)' }),
    exited: () => ({ opacity: 0, transform: 'translateY(-100%)' }),
  },
};

class Notification extends React.Component {
  constructor(props) {
    super(props);

    this.setTimer = this.setTimer.bind(this);
  }

  /**
   * SetTimerForClosing
   */
  setTimer() {
    const { onClose } = this.props;

    setTimeout(() => {
      onClose();
    }, 2000);
  }

  render() {
    const {
      children,
      isOpen,
      onClose,
      prefix,
      suffix,
      position,
      top,
      left,
      bottom,
      right,
      opacity,
      backdropFilter,
      ...rest
    } = this.props;
    let newTop;
    let newBottom;
    let newRight;
    let newLeft;

    switch (position) {
      case 'fromTopRight': {
        newBottom = 'auto';
        newLeft = 'auto';
        newTop = !top || top === 'auto' ? '32px' : top;
        newRight = !right || right === 'auto' ? '32px' : right;
        break;
      }
      case 'fromBottomRight': {
        newTop = 'auto';
        newLeft = 'auto';
        newBottom = !bottom || bottom === 'auto' ? '32px' : bottom;
        newRight = !right || right === 'auto' ? '32px' : right;
        break;
      }
      case 'fromBottomLeft': {
        newTop = 'auto';
        newRight = 'auto';
        newBottom = !bottom || bottom === 'auto' ? '32px' : bottom;
        newLeft = !left || left === 'auto' ? '32px' : left;
        break;
      }
      case 'fromTopLeft': {
        newBottom = 'auto';
        newRight = 'auto';
        newTop = !top || top === 'auto' ? '32px' : top;
        newLeft = !left || left === 'auto' ? '32px' : left;
        break;
      }
      default:
    }

    return (
      <Transition in={isOpen} timeout={duration} onEntering={this.setTimer} unmountOnExit>
        {(state) => (
          <Div
            style={{
              ...defaultNotifationStyle,
              ...transitionNotifationStyles[position][state](opacity, backdropFilter),
            }}
            top={newTop}
            bottom={newBottom}
            left={newLeft}
            right={newRight}
            {...rest}
          >
            {prefix}
            <Div flexGrow="1">{children}</Div>
            {suffix}
          </Div>
        )}
      </Transition>
    );
  }
}

/* eslint-disable react/require-default-props */

Notification.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node,
  isOpen: PropTypes.func,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  position: PropTypes.string,
  top: PropTypes.string,
  left: PropTypes.string,
  bottom: PropTypes.string,
  right: PropTypes.string,
  opacity: PropTypes.number,
  backdropFilter: PropTypes.string,
};

/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Notification.defaultProps = {
  pos: 'fixed',
  top: '32px',
  right: '32px',
  d: 'flex',
  align: 'center',
  bg: 'gray900',
  rounded: 'md',
  p: { x: '16px', y: '16px' },
  textColor: 'white',
  iconsSize: '18px',
  iconSize: '20px',
  textWeight: '600',
  w: '320px',
  zIndex: '1050',
  shadow: '3',
  position: 'fromTopRight',
  opacity: 1,
  backdropFilter: 'none',
};

/* eslint-enable react/default-props-match-prop-types */

export default Notification;
